import React, { useEffect, useState } from 'react'
import { CITIES } from '../data/content'

const SEQUENCE = [
  { word: 'Thank you', city: 'New York', color: '#EE352E' },
  { word: 'Merci',     city: 'Paris',    color: '#5F2D8A' },
  { word: 'Thank you', city: 'London',   color: '#E32017' },
  { word: 'Grazie',    city: 'Milano',   color: '#CC0000' },
  { word: 'Gracias',   city: 'Madrid',   color: '#E4032E' },
  { word: 'Danke',     city: 'Berlin',   color: '#F0CA00' },
]

export default function Splash({ onDone, theme, city }) {
  const [phase, setPhase] = useState('enter')
  const [cardIdx, setCardIdx] = useState(0)
  const cityData = CITIES[city] || CITIES.nyc
  const lineColor = cityData.primaryColor

  useEffect(() => {
    const CARD = 480
    const timers = []
    timers.push(setTimeout(() => setPhase('board'), 80))
    for (let i = 1; i < SEQUENCE.length; i++) {
      timers.push(setTimeout(() => setCardIdx(i), 80 + i * CARD))
    }
    const revealAt = 80 + SEQUENCE.length * CARD  // 2960ms
    timers.push(setTimeout(() => setPhase('reveal'), revealAt))
    timers.push(setTimeout(() => setPhase('exit'),   revealAt + 1400))
    timers.push(setTimeout(() => onDone(),           revealAt + 2000))
    return () => timers.forEach(clearTimeout)
  }, [onDone])

  const card     = SEQUENCE[cardIdx]
  const isGold   = card.color === '#F0CA00'
  const fg       = isGold ? '#111' : '#fff'
  const fgMute   = isGold ? 'rgba(0,0,0,0.45)' : 'rgba(255,255,255,0.55)'
  const showBoard    = phase === 'board'
  const showWordmark = phase === 'reveal' || phase === 'exit'
  const outerMod     = phase === 'enter' ? 'enter' : phase === 'exit' ? 'exit' : 'show'

  return (
    <div className={`splash-new splash-new--${outerMod}`}>

      {/* Full-screen colored bg for board phase */}
      <div className="splash-board-bg" style={{ background: card.color, opacity: showBoard ? 1 : 0 }}/>

      {/* Cycling thank-you board */}
      {showBoard && (
        <div className="splash-board">
          <div key={cardIdx} className="splash-board-card">
            <div className="splash-board-dot-top" style={{ background: fg }}/>
            <div className="splash-board-word" style={{ color: fg }}>{card.word}</div>
            <div className="splash-board-city" style={{ color: fgMute }}>{card.city.toUpperCase()}</div>
          </div>
          <div className="splash-board-dots">
            {SEQUENCE.map((_, i) => (
              <div key={i} className="splash-board-progress-dot"
                style={{
                  background: i === cardIdx ? fg : fgMute,
                  transform: i === cardIdx ? 'scale(1.5)' : 'scale(1)',
                }}/>
            ))}
          </div>
        </div>
      )}

      {/* Wordmark reveal */}
      {showWordmark && (
        <>
          <div className="splash-glow" style={{ background: lineColor }}/>
          <div className="splash-stripe"/>
          <div className="splash-new-inner">
            <div className="splash-wordmark">The Magic</div>
            <div className="splash-line" style={{ background: lineColor }}/>
          </div>
        </>
      )}
    </div>
  )
}
